export default __webpack_public_path__ + "static/media/prod-img-5.1ef0736b.webp";